import { useState, useContext, useRef, useEffect, useCallback, memo } from 'react';
import { UserSummaryContext } from '../contexts/UserSummaryContext'
import { Image } from 'react-bootstrap';
import { useDetectOutsideClick } from '../utils/useDetectOutsideClick';
import { useHoverContainment } from './hover/useHoverContainmentHooks';
import { profile_url } from '../helpers/url_helper';
import { useMediaQuery } from 'react-responsive';
import { mediaQueryConstants } from '../constants';

const UserAvatar = memo(function UserAvatar(props) { {
  const {
    name,
    name_initials,
    icon,
    size,
    className,
    user_id,
    workspace_id,
    organization_id,
    bordered,
    containerClassName,
    cached = true,
    openUserSummary,
    hoverableOnly = false,
  } = props

  const {
          setUserSummaryDetails,
          setIsActive,
          isActive
        } = useContext(UserSummaryContext);

  const [image_cached, setImageCached] = useState(false);
  const [image_url, setImageUrl] = useState(false);
  const [isHovered, hoverProps, containerRef] = useHoverContainment({
    enterDelay: 1000,
    moveDelay: 1000,
    leaveDelay: 0,
    containmentCheck: true
  });
  const isLargeScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.LARGE}px)` })

  useEffect(() => {
    if (!openUserSummary) return;
    if(isLargeScreen) return;

    if (isHovered ) {
      handleShow();
    } else {
      setIsActive(false);
    }
  }, [isHovered, openUserSummary, isLargeScreen]);

  useEffect(() => {
    if (image_cached && cached === true) {
      return null;
    }

    if (icon) {
      setImageUrl(icon)
      setImageCached(true);
    }
  }, [icon]);

  const handleShow = useCallback((e) => {
    if(!isActive && openUserSummary){
      e?.stopPropagation();

      const boundary = containerRef.current?.getBoundingClientRect();
      setIsActive(true);
      setUserSummaryDetails({id: null, boundary: boundary, user_id: user_id, workspace_id: workspace_id, organization_id: organization_id})
    }
  }, [isActive, openUserSummary, setIsActive, setUserSummaryDetails, user_id, workspace_id, organization_id]);

  const style = () => {
    return {
      float: 'left',
      height: '' + size + 'px',
      minWidth: '' + size + 'px',
      width: '' + size + 'px',
      fontSize: '' + (parseInt(size) * 0.5) + 'px',
      border: bordered ? '3px solid' : 'none',
      textAlign: 'center'
    }
  }

  const imageStyle = () => {
    return {
      float: 'left',
      height: '' + size + 'px',
      width: '' + size + 'px',
      border: bordered ? '3px solid white' : 'none'
    }
  }

  const onClick = (e) => {
    if(!openUserSummary) return;
    if(hoverableOnly) return;
    
    
    if(isLargeScreen){
      handleShow();
    } else {
      e.stopPropagation();
      window.location = profile_url(user_id)
    }

    return true;
  }

  return (
    <>
      <div
        onClick={onClick}
        ref={containerRef}
        className={`${containerClassName}`}
        {...hoverProps}
      >
        {
          image_url ?
            <Image
              src={ image_url }
              title={ name }
              alt={ name }
              roundedCircle
              className={ className }
              style={imageStyle()}
            />
          :
            <div
              className={`user-avatar ${className}`}
              style={style()}
            >
              <div>{ name_initials }</div>
            </div>
        }
      </div>
    </>
  );
}});

export { UserAvatar };
